var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.contacts, function (contact) {
    return _c('v-card', {
      key: 'contacts-shared-' + contact.id,
      staticClass: "mx-4  mt-6",
      attrs: {
        "flat": "",
        "outlined": ""
      }
    }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("objects.report.personIds")) + " ")]), _c('v-card-text', [contact.firstName || contact.lastName ? _c('m-text-field', {
      attrs: {
        "label": _vm.$t('common.nouns.name'),
        "value": "".concat(contact.firstName, " ").concat(contact.lastName),
        "readonly": "",
        "hide-details": ""
      }
    }) : _vm._e(), contact.emails && contact.emails.length ? _c('m-text-field', {
      attrs: {
        "label": _vm.$t('common.nouns.email'),
        "value": "".concat(contact.emails[0].email),
        "readonly": "",
        "hide-details": ""
      }
    }) : _vm._e(), contact.phones && contact.phones.length ? _c('m-text-field', {
      attrs: {
        "label": _vm.$t('common.nouns.phone'),
        "value": "".concat(contact.phones[0].phone),
        "readonly": "",
        "hide-details": ""
      }
    }) : _vm._e()], 1)], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }